"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var BooleanDropdownField = /** @class */ (function (_super) {
    __extends(BooleanDropdownField, _super);
    function BooleanDropdownField(key, label, isRequired, requiredMessage, initialValue) {
        var _this = _super.call(this, key, label, isRequired, isRequired ? [
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' }
        ] : [
            { label: 'All', value: '' },
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' }
        ], requiredMessage, initialValue, _1.FieldType.DropDown) || this;
        _this.key = key;
        return _this;
    }
    return BooleanDropdownField;
}(_1.StringDropdownField));
exports.default = BooleanDropdownField;
